import { styled, Typography } from '@mui/material';

function Info(props: { label: string; value: string }) {
    return (
        <Container>
            <Label>{props.label} :</Label>
            <Value>{props.value}</Value>
        </Container>
    );
}

const Container = styled('div')(({ theme }) => ({ display: 'flex' }));
const Label = styled(Typography)(({ theme }) => ({ marginRight: theme.spacing(1) }));
const Value = styled(Typography)(({ theme }) => ({ fontWeight: 'bold' }));

export { Info };
